import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
type FaqItemProps = {
  id: string;
  question: string;
  answer: string;
};
export function FaqItem({
  id,
  question,
  answer
}: FaqItemProps) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-line" data-id="element-79" data-mp="3dqsl7eopss1x">
      <h3 className="!mt-0" data-id="element-80" data-mp="38rzafu0tbf5g">
        <button type="button" id={`${id}-button`} aria-expanded={open} aria-controls={`${id}-panel`} onClick={() => setOpen(v => !v)} className="flex w-full items-start justify-between gap-6 py-5 text-left font-sans text-lg font-semibold text-ink hover:text-aurora-cyan" data-id="element-81" data-mp="38tsfj4vs1rbc">
          {question}
          <PlusIcon aria-hidden="true" className={`mt-1 h-5 w-5 shrink-0 text-aurora-cyan transition-transform duration-200 ${open ? 'rotate-45' : ''}`} data-id="element-82" data-mp="2q1hj9tvmorm7" />
        </button>
      </h3>
      <div id={`${id}-panel`} role="region" aria-labelledby={`${id}-button`} className={`grid transition-[grid-template-rows] duration-200 ease-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-83" data-mp="1xe3syemfqub2">
        <div className="overflow-hidden" aria-hidden={!open} data-id="element-84" data-mp="3rr0m47ddw0bx">
          <p className="pb-5 pr-10" data-id="element-85" data-mp="f8lnz053wyx">{answer}</p>
        </div>
      </div>
    </div>;
}